const Inward = {

    // FIELDS
    "department": "Department",
    "location": "Location",
    "component": "Component",
    "equipment": "Equipment",
    "new_part_no": "New Part No",
    "old_part_no": "Old Part No",
    "km_item_code": "KM Item Code",
    "imcf_no": "IMCF No",
    "date": "Date",
    "quantity": "Quantity",
    "search": "Search",

    // PAGE HEADER
    "inward": "Inward",

    // ERROR
    "error_department": "Select Department",
    "error_location": "Select Location",
    "error_component": "Select Component",
    "error_equipment": "Select Equipment",
    "error_imcf_no": "Enter IMCF No",
    "error_date": "Select Date",
    "error_quantity": "Enter Quantity",
    "error_quantity_positive": "Quantity must be positive",

    // TABLE HEADER
    "table_department": 'DEPARTMENT',
    "table_location": 'LOCATION',
    "table_component": 'COMPONENT',
    "table_equipment": 'EQUIPMENT',
    "table_make": "MAKE",
    "table_new_part_number": "NEW PART NUMBER",
    "table_old_part_number": "OLD PART NUMBER",
    "table_km_item_code": "KM ITEM CODE",
    "table_imcf_no": 'IMCF NO',
    "table_date": "DATE",
    "table_quantity": "QUANTITY",

}

export default Inward;